<div class="title" *ngIf="title"
    [ngStyle]="{'color': color}"
>{{title}}</div>

<audio id="audio-player">
    <source [src]="audio" type="audio/mpeg">
</audio>

<img id="btn-play" src="../../../assets/img/conference/play.svg" (click)="play()">
<img id="btn-pause" class="hide" src="../../../assets/img/conference/pause.svg" (click)="pause()">

<div class="duration"
    [ngStyle]="{'color': color}"
>{{round(duration)}} {{ "__CONFERENCE_SECONDS__" | translate }}</div>
